import './index.css';
import { jsx } from 'react/jsx-runtime';
import { useRef, useState, useCallback, useLayoutEffect } from 'react';
import { useResize } from '@hh.ru/magritte-common-resize';

const FullPageContainer = ({ children }) => {
    const ref = useRef(null);
    const [padding, setPadding] = useState(undefined);
    const calcPadding = useCallback(() => {
        if (ref.current) {
            const pageWidth = document.body.clientWidth;
            const parentElement = ref.current.parentElement;
            const contentRect = parentElement.getBoundingClientRect();
            setPadding({ paddingLeft: contentRect.left, paddingRight: pageWidth - contentRect.right });
        }
    }, []);
    useLayoutEffect(() => {
        if (ref.current) {
            const observer = new ResizeObserver(() => calcPadding());
            observer.observe(document.body);
            return () => observer.disconnect();
        }
        return void 0;
    }, [calcPadding]);
    useResize(calcPadding);
    return (jsx("div", { ref: ref, style: padding
            ? { marginLeft: `-${padding.paddingLeft}px`, marginRight: `-${padding.paddingRight}px` }
            : undefined, children: padding ? children(padding) : null }));
};

export { FullPageContainer };
//# sourceMappingURL=FullPageContainer.js.map
